export const UPPERCASE_REGEX = /[A-Z]/;
export const SPECIAL_CHAR_REGEX = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
